// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__SRY71","Card__name":"Card_Card__name__qu1Hv","Card__info":"Card_Card__info__+On4R"};